import { render } from "./TabStep.vue?vue&type=template&id=5318fbae&scoped=true"
import script from "./TabStep.vue?vue&type=script&lang=js"
export * from "./TabStep.vue?vue&type=script&lang=js"

import "./TabStep.vue?vue&type=style&index=0&id=5318fbae&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5318fbae"]])

export default __exports__